import React from 'react';
import PropTypes from 'prop-types';
import { formatNumberToLocale } from '@alphapoint/apex-web/lib/helpers/numberFormatter';
import * as level1DataProp from '@alphapoint/apex-web/lib/propTypes/level1Data';
import Marquee from './components/TickerBase';
import './TickerComponent.css';

class TickerComponent extends React.Component {
  render() {
    const { level1, instruments, icons, direction, speed } = this.props;
    return (
      <div className="ticker-marquee">
        <Marquee direction={direction} speed={speed} autoFill>
          {instruments.map((instrument) => {
            const level1Data = level1[instrument.InstrumentId] || {};
            const lastTrade = level1Data['LastTradedPx'];

            const colorClass = level1Data['Rolling24HrPxChange'] < 0 ? 'trade_down' : 'trade_up';
            const instrumentSymbol = instrument.Product1Symbol;
            return (
              <div
                className="ticker-block"
                key={instrument.InstrumentId}
                style={lastTrade <= 0 ? { display: 'none' } : {}}>
                <p className="ticker-symbol">
                  <span className="ticker-symbol__icon">
                    <img src={`/local/product-icons/${icons?.[instrumentSymbol]?.iconFileName ?? ''}`} alt="" />
                  </span>
                  {instrument.Symbol}
                </p>
                <p className="ticker-last-trade">
                  <span className={colorClass}>{formatNumberToLocale(lastTrade, instrument.Symbol)}</span>
                  <span className="currency">{instrument.Product2Symbol}</span>
                </p>
              </div>
            );
          })}
        </Marquee>
      </div>
    );
  }
}

TickerComponent.propTypes = {
  instruments: PropTypes.array.isRequired,
  show24HrPxChange: PropTypes.bool,
  show24HrVolume: PropTypes.bool,
  direction: PropTypes.string,
};

TickerComponent.defaultProps = {
  level1: level1DataProp.defaultProps,
};

export default TickerComponent;
